import React, { Component } from "react";
import { connect } from "react-redux";
import { withStyles, MuiThemeProvider } from "@material-ui/core/styles";
import foodbookTheme from "../../hoc/Theme";
import Button from "@material-ui/core/Button";
import RefreshIcon from "@material-ui/icons/Refresh";
import ErrorImage from "../../assets/images/broken-egg.svg";
import { clearItemsInCart } from "../../store/actionCreators/cartItems";
import ProgressCircular from "./CircularProgress";

const styles = theme => ({
  Container: {
    height: "100%",
    width: "100%",
    position: "absolute",
    top: "0px",
    zIndex: "999",
    backgroundColor: "white"
  },
  Content: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    textAlign: "center"
  },
  Header: {
    marginBottom: "0px",
    fontSize: "50px",
    color: "#F37020"
  },
  Text: {
    marginTop: "0px"
  },
  Icon: {
    margin: "0px auto",
    display: "block",
    padding: "20px 0px"
  }
});

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, circularProgress: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // You can also log the error to an error reporting service
    this.setState({ hasError: true });
  }

  reloadActionHandler = () => {
    this.setState({ circularProgress: true });
    this.props.clearItemsInCart();
    localStorage.removeItem("processCart");
    /* since using throttle with a delay of 2 seconds,
    kept a delay so that cart items are cleared in local storage as well */
    setTimeout(() => window.location.reload(), 2100);
  };

  render() {
    const { classes } = this.props;
    const { circularProgress } = this.state;
    const { Container, Content, Header, Text, Icon } = classes;
    if (this.state.hasError) {
      return (
        <div className={Container}>
          {circularProgress ? <ProgressCircular loading /> : null}
          <div className={Content}>
            <h2 className={Header}>OOPS!</h2>
            <h2 className={Text}>Something went wrong. Please try again.</h2>
            <img className={Icon} src={ErrorImage} />
            <MuiThemeProvider theme={foodbookTheme}>
              <Button
                onClick={this.reloadActionHandler}
                color="primary"
                variant="raised"
              >
                <RefreshIcon />
                Reload
              </Button>
            </MuiThemeProvider>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearItemsInCart: () => {
      dispatch(clearItemsInCart());
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(ErrorBoundary));



// WEBPACK FOOTER //
// ./src/components/Utils/ErrorBoundary.js